import useUserData from "../../../hooks/user/useUserData";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {CALCULATIONS} from "../locales/namespaces";
import * as yup from "yup";
import {API} from "../../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {getRouteUrl} from "../../../helpers/getRouteUrl";
import {ROUTE_PAGE_CALCULATIONS_EDIT} from "../routes/routes";
import {handleAxiosErrors, logoutUnauthorizedUser} from "../../../helpers/errorHandling";
import {useFormik} from "formik";
import axios from "axios";
import {TypeInterestRate, TypeInterestRateIds} from "../../../parameters/parameters";
import moment from "moment";
import {calculateInstallments, calculateLtv} from "../helpers/calculations";
import {useState, useEffect} from "react";
import useUserAction from "../../../hooks/user/useUserAction";
import { useLocation } from 'react-router-dom';
import { showPopup } from '../../../../src/components/globalPopup/globalPopupService';

import { useDispatch, useSelector } from 'react-redux';
import { SHOW_LOADER, HIDE_LOADER } from '../../../actions/types';

const useCalculationForm = ({id, calculations, interests, contributions, repayments}) => {
	const location = useLocation();
    const dispatch = useDispatch();




	const queryParams  =      new URLSearchParams(window.location.search);


	const getParamNumber = (key) => {
		const value = queryParams.get(key);
		return value !== null && !isNaN(value) ? Number(value) : null;
	};

	const rawDate = queryParams.get("DateInstallment");
	const parsedDate = rawDate ? JSON.parse(rawDate) : null;

	const isCreateRoute = location.pathname.includes("create");
	const {token, isLoggedIn} = useUserData()
	const {userLogout} = useUserAction()
	const history = useHistory()
	const {t} = useTranslation(CALCULATIONS)
	const [isLoading, setIsLoading] = useState(false);
	const mapRepayments = repayments.map(repayment => ({
		Amount: Number(repayment.Amount),
		NewRate: Number(repayment.NewRate),
		Repayment_dt: moment(repayment.PaymentDt).format('MM/DD/YYYY')
	}))

	const getParamDecimalString = (key, decimals = 2) => {
		const value = queryParams.get(key);
		if (value === null || isNaN(value)) return null;
		return Number(value).toFixed(decimals);
	};

	const getParamStringNumber = (key) => {
		const value = queryParams.get(key);
		return value !== null && !isNaN(value) ? String(Number(value)) : null;
	};
	

	const initialValues = {
		RealEstateValue: getParamNumber("RealEstateValue") ?? (
			Object.keys(calculations).length > 0
				? calculations?.RealEstateValue
				: interests.RealEstateValue
		),
	
		LoanAmount: getParamNumber("LoanAmount") ?? (calculations?.LoanAmount || interests.LoanAmount),
	
		Ltv: calculateLtv(
			getParamNumber("RealEstateValue") ?? calculations?.RealEstateValue ?? 100000,
			getParamNumber("LoanAmount") ?? calculations?.LoanAmount ?? 80000
		),
	
		InterestType: getParamNumber("InterestType") ?? (
			calculations?.InterestType
				?? TypeInterestRate.filter(f => f.isDefault === 1)[0].id
		),
	
		FixedInterestRate: getParamDecimalString("FixedInterestRate") ?? (
			Object.keys(calculations).length > 0
				? calculations?.FixedInterestRate?.toFixed(2)
				: parseFloat(interests.StableInterest).toFixed(2)
		),
	
		FixedDuration: getParamNumber("FixedDuration") ?? (
			Object.keys(calculations).length > 0
				? calculations?.FixedDuration
				: 30
		),
	
		Spread: getParamNumber("Spread") ?? (
			Object.keys(calculations).length > 0 ? calculations?.Spread : 0
		),
	
		Euribor: getParamNumber("Euribor") ?? (
			Object.keys(calculations).length > 0 &&
			(TypeInterestRateIds.Floating || TypeInterestRateIds.Hybrid)
				? interests.Euribor
				: 0
		),
	
		FloatingDuration: getParamNumber("FloatingDuration") ?? (
			Object.keys(calculations).length > 0 ? calculations?.FloatingDuration : 0
		),
	
		Contribution: getParamStringNumber("Contribution") ?? (
			calculations?.ContributionId
				? String(contributions.find(f => f.id === calculations.ContributionId)?.id)
				: (String(contributions.find(f => f.isDefault === '1')?.id) ?? '')
		),
	
		TotalDuration: getParamNumber("TotalDuration") ?? (calculations?.TotalDuration || 0),
		InstallmentNumber: getParamNumber("InstallmentNumber") ?? (calculations?.InstallmentNumber || 0),
	
		DateInstallment: parsedDate
		? moment(parsedDate).startOf("day")
		: (calculations?.DateInstallment
			? moment(calculations.DateInstallment, "DD/MM/YYYY")
			: moment().startOf("day")),
		isMonthly: queryParams.get("isMonthly") ? queryParams.get("isMonthly") : calculations?.isMonthly ? calculations?.isMonthly  : 'isYearly',
		isHidePreviousInstallments: queryParams.get("isHidePreviousInstallments") ? queryParams.get("isHidePreviousInstallments") === "true" : calculations?.isHidePreviousInstallments,
		NotifyFlag: queryParams.get("NotifyFlag") ? queryParams.get("NotifyFlag")  : calculations?.NotifyFlag,
	
		Description: queryParams.get("Description") ?? calculations?.Description ?? '',
	}


	
	const [results, setResults] = useState(calculateInstallments(
		0,
		initialValues.FixedDuration,
		initialValues.FloatingDuration,
		initialValues.FixedInterestRate,
		initialValues.Spread + initialValues.Euribor,
		contributions.find(f => f.id === initialValues.Contribution)?.Value,
		initialValues.LoanAmount,
		initialValues.isMonthly === 'isMonthly',
		initialValues.isHidePreviousInstallments,
		moment(initialValues.DateInstallment).format('MM/DD/YYYY'),
		[...mapRepayments],
		[],
		[],
		0,
		0,
		0,
		0,
		[...mapRepayments],
	))
	
	const handleResults = (updateResults) => setResults(updateResults)

	// Keep results in sync with repayments
	useEffect(() => {
		// Only update if formik values are ready and valid
		if (!formik.values || !formik.values.FixedDuration) return

		const currentMapRepayments = repayments?.map(repayment => ({
			Amount: Number(repayment.Amount),
			NewRate: Number(repayment.NewRate),
			Repayment_dt: moment(repayment.PaymentDt).format('MM/DD/YYYY')
		}))

		setResults(calculateInstallments(
			0,
			formik.values.FixedDuration,
			formik.values.FloatingDuration,
			formik.values.FixedInterestRate,
			Number(formik.values.Spread) + Number(formik.values.Euribor),
			contributions.find(f => f.id === formik.values.Contribution)?.Value,
			formik.values.LoanAmount,
			formik.values.isMonthly === 'isMonthly',
			formik.values.isHidePreviousInstallments,
			moment(formik.values.DateInstallment).format('MM/DD/YYYY'),
			[...currentMapRepayments],
			[],
			[],
			0,
			0,
			0,
			0,
			[...currentMapRepayments]
		))
	}, [repayments])
	
	const validationSchema = yup.object({
		Description: yup.string().required(t('Required')),
		RealEstateValue: yup.number().positive(t('Value must be a positive number.')).min(0, t('Value must be a positive number.')).max(99999999.99, t('Real estate value must be less than 100,000,000.')),
		LoanAmount: yup.number().required(t('Required')).positive(t('Value must be a positive number.')).min(0, t('Value must be a positive number.')).max(99999999.99, t('Loan amount must be less than 100,000,000.')),
		FixedInterestRate: yup.number().positive(t('Value must be a positive number.')).min(0, t('Value must be a positive number.')).max(99, t('The value is too big.')).test(
			'Required', t('Required'),
			function (value) {
				return !(((this.parent['InterestType'] === 1 || this.parent['InterestType'] === 3) && this.parent['FixedInterestRate'] === undefined) && this.parent['InterestType'] !== 2)
			}
		),
		FixedDuration: yup.number().integer(t('Value must be an integer number.')).min(0, t('Value must be a positive number.')).max(45, t('The value is too big.')).test(
			'Required', t('Required'),
			function (value) {
				return !(((this.parent['InterestType'] === 1 || this.parent['InterestType'] === 3) && this.parent['FixedDuration'] === undefined) && this.parent['InterestType'] !== 2)
			}
		).test('sum', t('The total duration of the loan cannot exceed 45 years'), function (value) {
			const {FixedDuration, FloatingDuration} = this.parent;
			if (FixedDuration !== undefined && FloatingDuration !== undefined) {
				return FixedDuration + FloatingDuration <= 45;
			}
			return true;
		}),
		Spread: yup.number().positive(t('Value must be a positive number.')).min(0, t('Value must be a positive number.')).max(100, t('The value is too big.'))
		.test(
			'Required', t('Required'),
			function (value) {
				return !(((this.parent['InterestType'] === 2 || this.parent['InterestType'] === 3) && this.parent['Spread'] === undefined) && this.parent['InterestType'] !== 1)
			}
		),
		FloatingDuration: yup.number().integer(t('Value must be an integer number.')).min(0, t('Value must be a positive number.')).max(45, t('The value is too big.')).test(
			'Required', t('Required'),
			function (value) {
				return !(((this.parent['InterestType'] === 2 || this.parent['InterestType'] === 3) && this.parent['FloatingDuration'] === undefined) && this.parent['InterestType'] !== 1)
			}
		).test('sum', t('The total duration of the loan cannot exceed 45 years'), function (value) {
			const {FixedDuration, FloatingDuration} = this.parent;
			if (FixedDuration !== undefined && FloatingDuration !== undefined) {
				return FixedDuration + FloatingDuration <= 45;
			}
			return true;
		}),
		DateInstallment: yup.date().typeError(t('Value must be a valid date.')).required(t('Required'))
	})
	
	const onSubmit = (values) => {
		dispatch({ type: SHOW_LOADER });
		axios({
			method: 'post',
			data: {
				CalculationId: id,
				RealEstateValue: values.RealEstateValue,
				RequestedAmount: values.LoanAmount,
				TypeId: values.InterestType,
				FixedRate: values.FixedInterestRate,
				FixedDuration: values.FixedDuration,
				Euribor: values.Euribor,
				Spread: values.Spread,
				FloatDuration: values.FloatingDuration,
				ContributionId: values.Contribution,
				isMonthly: values.isMonthly === 'isMonthly',
				HidePrevious: values.isHidePreviousInstallments ? values.isHidePreviousInstallments : false,
				NotifyFlag: values.NotifyFlag ? values.NotifyFlag : false,
				Description: values.Description,
				StartDt: values.DateInstallment ? moment(values.DateInstallment).format('YYYY-MM-DD') : null,
			},
			headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
			url: isCreateRoute ? `${API}/calculation/store` : `${API}/calculation/update`
		}).then(response => {
			// enqueueSnackbar(!id ? t('Calculation Stored Successfully!') : t('Calculation Updated Successfully!'), {
			// 	variant: 'success',
			// 	onClose: () => history.push(getRouteUrl(ROUTE_PAGE_CALCULATIONS_EDIT, {id: response.data.CalculationId}))
			// })
			showPopup({
				title: '',
				message:  !id ? t('Calculation Stored Successfully!') : t('Calculation Updated Successfully!'),
				onConfirm: () => {
					history.push(getRouteUrl(ROUTE_PAGE_CALCULATIONS_EDIT, {id: response.data.CalculationId}))
				}
			});

			dispatch({ type: HIDE_LOADER });
		}).catch((error) => {
			// enqueueSnackbar(handleAxiosErrors(error, t('Failed to get calculation.')), {
			// 		variant: 'error'
			// 	}
			// )

			showPopup({
				title: '',
				message:  t('Something went wrong. Please try again or contact support.'),
				onConfirm: () => {
					
				}
			});



			dispatch({ type: HIDE_LOADER });
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}
	
	const formik = useFormik({
		initialValues: initialValues,
		validationSchema: validationSchema,
		onSubmit: onSubmit
	})
	
	// Handler when I change the value of LoanAmount and calculate the Ltv
	const handleCalculationsLoanAmount = (event, fieldName) => {
		const {value} = event.target;
		const otherFieldName = fieldName === "LoanAmount" ? "RealEstateValue" : "LoanAmount";
		const otherFieldValue = parseInt(formik.values[otherFieldName]);
		const Ltv = calculateLtv(otherFieldValue, value)
		formik.setFieldValue(fieldName, value);
		formik.setFieldValue("Ltv", Ltv);
		handleCalculateInstallments({
			target: {
				name: fieldName,
				value: value,
			},
		});
	};
	
	// Handler when I change the value of RealEstateValue and calculate the Ltv
	const handleCalculationsRealEstateValue = (event, fieldName) => {
		const {value} = event.target;
		const otherFieldName = fieldName === "RealEstateValue" ? "LoanAmount" : "RealEstateValue";
		const otherFieldValue = parseInt(formik.values[otherFieldName]);
		const Ltv = calculateLtv(value, otherFieldValue)
		formik.setFieldValue(fieldName, value);
		formik.setFieldValue("Ltv", Ltv);
	};
	
	const TotalDuration = Number(formik.values.FixedDuration) + Number(formik.values.FloatingDuration)
	const InstallmentNumber = TotalDuration * 12
	
	const handleCalculateInstallments = (event) => {
		const currentMapRepayments = repayments.map(repayment => ({
			Amount: Number(repayment.Amount),
			NewRate: Number(repayment.NewRate),
			Repayment_dt: moment(repayment.PaymentDt).format('MM/DD/YYYY')
		}))

		const {name, value, checked} = event.target;
		formik.setFieldValue(name, value === 'on' ? checked : value);
		setResults(calculateInstallments(
			0,
			name === 'FixedDuration' ? value : formik.values.FixedDuration,
			name === 'FloatingDuration' ? value : formik.values.FloatingDuration,
			name === 'FixedInterestRate' ? value : formik.values.FixedInterestRate,
			name === 'Spread' ? Number(value) + Number(formik.values.Euribor) : Number(formik.values.Spread) + Number(formik.values.Euribor),
			name === 'Contribution' ? contributions.find(f => f.id === value).Value : contributions.find(f => f.id === formik.values.Contribution).Value,
			name === 'LoanAmount' ? value : formik.values.LoanAmount,
			name === 'isMonthly' ? value === 'isMonthly' : formik.values.isMonthly === 'isMonthly',
			name === 'isHidePreviousInstallments' ? checked : formik.values.isHidePreviousInstallments,
			name === 'DateInstallment' ? moment(value).format('MM/DD/YYYY') : moment(formik.values.DateInstallment).format('MM/DD/YYYY'),
			[...currentMapRepayments],
			[],
			[],
			0,
			0,
			0,
			0,
			[...currentMapRepayments]
		));
	};
	
	const handleInterestType = (event) => {
		const currentMapRepayments = repayments.map(repayment => ({
			Amount: Number(repayment.Amount),
			NewRate: Number(repayment.NewRate),
			Repayment_dt: moment(repayment.PaymentDt).format('MM/DD/YYYY')
		}))

		const {value} = event.target;
		const interestType = TypeInterestRate.find((item) => item.id === Number(value));
		const updateValues = {}
		if (interestType.DescriptionEn === 'Fixed') {
			updateValues.FixedInterestRate = parseFloat(interests.StableInterest).toFixed(2)
			updateValues.FixedDuration = 30
			updateValues.Euribor = ''
			updateValues.Spread = ''
			updateValues.FloatingDuration = 0
		} else if (interestType.DescriptionEn === 'Floating') {
			updateValues.FixedInterestRate = ''
			updateValues.FixedDuration = 0
			updateValues.Euribor = interests.Euribor
			updateValues.Spread = parseFloat(interests.Spread).toFixed(2)
			updateValues.FloatingDuration = 30
		} else if (interestType.DescriptionEn === 'Fixed and Floating') {
			updateValues.FixedInterestRate = parseFloat(interests.StableInterest).toFixed(2)
			updateValues.FixedDuration = 15
			updateValues.Euribor = interests.Euribor
			updateValues.Spread = parseFloat(interests.Spread).toFixed(2)
			updateValues.FloatingDuration = 15
		}
		formik.setValues({
			...formik.values,
			...updateValues,
			InterestType: value
		});
		setResults(calculateInstallments(
			0,
			updateValues.FixedDuration,
			updateValues.FloatingDuration,
			updateValues.FixedInterestRate,
			parseFloat(updateValues.Spread) + updateValues.Euribor,
			formik.values.Contribution ? contributions.find(f => f.id === formik.values.Contribution).Value : contributions.find(f => f.isDefault === '1').Value,
			formik.values.LoanAmount,
			formik.values.isMonthly === 'isMonthly',
			formik.values.isHidePreviousInstallments,
			moment(formik.values.DateInstallment).format('MM/DD/YYYY'),
			[...currentMapRepayments],
			[],
			[],
			0,
			0,
			0,
			0,
			[...currentMapRepayments]
		))
	};
	
	const handleDate = (newValue) => {
		handleCalculateInstallments({
			target: {
				name: 'DateInstallment',
				value: newValue,
			},
		});
	}
	
	const handleResetForm = () => {
		const resetValues = {
			...initialValues,
			LoanAmount: initialValues.LoanAmount,
			RealEstateValue: interests.RealEstateValue,
			Ltv: calculateLtv(100000, 80000),
			InterestType: TypeInterestRate.filter(f => f.isDefault === 1)[0].id,
			FixedInterestRate: interests.StableInterest,
			FixedDuration: 30,
			Euribor: initialValues.Euribor,
			Spread: initialValues.Spread,
			FloatingDuration: 0,
			Contribution: contributions.length > 0 ? contributions.find(f => f.isDefault === '1')?.id : '',
			TotalDuration: 0,
			InstallmentNumber: 0,
			DateInstallment: moment().startOf('day'),
			isMonthly: 'isMonthly',
			isHidePreviousInstallments: false
		};
		
		formik.resetForm({values: resetValues});
		
		setResults(
			calculateInstallments(
				0,
				resetValues.FixedDuration,
				resetValues.FloatingDuration,
				resetValues.FixedInterestRate,
				resetValues.Spread + resetValues.Euribor,
				contributions.find((f) => f.id === resetValues.Contribution)?.Value,
				resetValues.LoanAmount,
				resetValues.isMonthly === "isMonthly",
				resetValues.isHidePreviousInstallments,
				moment(resetValues.DateInstallment).format("MM/DD/YYYY"),
				[],
				[],
				[],
				0,
				0,
				0,
				0,
				[]
			)
		);
	};
	
	return {
		formik,
		results,
		TotalDuration,
		InstallmentNumber,
		handleDate,
		handleResults,
		handleInterestType,
		handleCalculateInstallments,
		handleCalculationsLoanAmount,
		handleCalculationsRealEstateValue,
		handleResetForm,
		isLoading
	}
}
export default useCalculationForm